import _ from 'lodash'

export const calculatePremiumCharge = (feeStructure, policyYear, premiumValue) => {
  const premiumChargeForGivenYear = _.find(feeStructure, { policyYear }) || { charge: 0 }
  return premiumValue.times(premiumChargeForGivenYear.charge)
}

export const regularPremiumCharge = (policyYear, regularPremium, feeStructure) => {
  return calculatePremiumCharge(feeStructure.regularPremiumCharge, policyYear, regularPremium)
}

export const regularTopUpCharge = (policyYear, regularTopUp, feeStructure) => {
  return calculatePremiumCharge(feeStructure.regularTopUpCharge, policyYear, regularTopUp)
}

export const lumpSumTopUpCharge = (lumpSum, feeStructure) => lumpSum.times(feeStructure.lumpSumpCharge)

export const premiumChargeIwealthy = (feeStructure) => (policyYear, { regularPremium, regularTopUp, lumpSum }) =>
  regularPremiumCharge(policyYear, regularPremium, feeStructure)
    .plus(regularTopUpCharge(policyYear, regularTopUp, feeStructure))
    .plus(lumpSumTopUpCharge(lumpSum, feeStructure))

// FIXME
export const premiumChargeIinvest = (feeStructure) => (policyYear, { regularPremium }) =>
  regularPremiumCharge(policyYear, regularPremium, feeStructure)

// //should return object
// export const premiumChargeUdr = (feeStructure: FeeStructure) => (
//   policyYear: number,
//   { regularPremium, lumpSum }: PremiumInput
// ): Decimal =>
//   regularPremiumCharge(policyYear, regularPremium, feeStructure).plus(lumpSumTopUpCharge(lumpSum, feeStructure))
